module.exports = __webpack_public_path__ + "static/media/kdd4.7005ba16.png";